import React from 'react';
import { injectTestId } from '@cvent/nucleus-test-automation';
import useIllustrationColor from '@cvent/blocks/hooks/useIllustrationColor';
import { SVGInterface } from '@images/SVGInterface';

interface OnDemandSVGProps {
  testID: string;
}

function LightBackgroundOnDemandSVG({ color }: SVGInterface): JSX.Element {
  return (
    <svg width="156" height="155" viewBox="0 0 156 155" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1522_113)">
        <path
          opacity="0.1"
          d="M78.0001 0.00461314C63.4455 0.148902 51.772 1.27529 34.0477 12.8184C22.8117 20.1353 15.1225 32.1951 9.42075 44.3293C-8.93657 83.3945 3.55609 114.203 13.0373 126.23C16.9936 131.247 24.5991 137.294 30.1565 140.901C63.1941 162.33 99.5504 151.299 102.32 150.545C109.865 148.483 148.385 136.409 155.348 94.1185C155.93 90.595 156.312 87.0576 155.632 83.5528C154.273 76.5571 151.42 69.8592 147.315 64.0318C145.099 60.8854 142.516 57.9717 140.771 54.546C138.42 49.9334 137.736 44.6877 136.381 39.6888C129.265 13.3956 112.481 -0.339819 78.0001 0.00461314Z"
          fill={color}
        />
        <path
          d="M124.014 56.9104C123.991 56.4496 123.595 56.0959 123.135 56.1192L43.0633 60.4525C42.9888 59.0748 42.6072 57.7762 41.9695 56.6405L123.167 47.8295C123.474 47.7969 123.698 47.5223 123.661 47.2151L121.92 31.1757C121.724 29.3791 120.114 28.0852 118.317 28.2806L34.2617 37.3988C32.465 37.5943 31.1711 39.2047 31.3666 41.0014L32.5861 52.2606C28.4994 53.0379 25.4042 56.6218 25.4042 60.9366C25.4042 65.5585 28.9556 69.3472 33.4797 69.7382L35.8256 113.099C35.914 114.729 37.3057 115.981 38.9394 115.892L123.986 111.294C125.615 111.205 126.867 109.813 126.779 108.18L124.005 56.9104H124.014Z"
          fill={color}
        />
        <path
          d="M124.014 56.9108C123.991 56.45 123.595 56.0963 123.135 56.1195L43.0634 60.4529C42.989 59.0751 42.6073 57.7765 41.9696 56.6408L123.167 47.8299C123.474 47.7973 123.698 47.5227 123.661 47.2155L121.92 31.1761C121.724 29.3795 120.114 28.0855 118.317 28.281L34.2618 37.3992C32.4652 37.5946 31.1712 39.2051 31.3667 41.0017L32.5862 52.261C28.4995 53.0383 25.4043 56.6222 25.4043 60.9369C25.4043 65.5588 28.9557 69.3476 33.4798 69.7386L35.8257 113.1C35.9141 114.729 37.3058 115.981 38.9396 115.893L123.986 111.294C125.616 111.205 126.868 109.814 126.779 108.18L124.005 56.9108H124.014Z"
          fill="black"
          fillOpacity="0.2"
        />
        <path
          d="M93.6112 81.8027L75.5052 72.6147C74.2624 71.9863 72.8056 72.9358 72.8801 74.3229L73.9785 94.5932C74.053 95.9849 75.6076 96.7715 76.7712 96.0082L93.7787 84.9212C94.947 84.1625 94.8493 82.4217 93.6112 81.7933V81.8027Z"
          fill="white"
        />
        <path
          d="M138.634 115.636C140.937 115.636 142.804 113.769 142.804 111.466C142.804 109.163 140.937 107.295 138.634 107.295C136.331 107.295 134.464 109.163 134.464 111.466C134.464 113.769 136.331 115.636 138.634 115.636Z"
          fill={color}
        />
        <path
          d="M138.634 115.636C140.937 115.636 142.804 113.769 142.804 111.466C142.804 109.162 140.937 107.295 138.634 107.295C136.331 107.295 134.464 109.162 134.464 111.466C134.464 113.769 136.331 115.636 138.634 115.636Z"
          fill="black"
          fillOpacity="0.3"
        />
        <path
          d="M15.6019 50.464C17.2265 50.464 18.5436 49.1469 18.5436 47.5223C18.5436 45.8977 17.2265 44.5807 15.6019 44.5807C13.9773 44.5807 12.6603 45.8977 12.6603 47.5223C12.6603 49.1469 13.9773 50.464 15.6019 50.464Z"
          fill={color}
        />
        <path
          d="M129.195 124.922C130.303 124.922 131.201 124.024 131.201 122.916C131.201 121.808 130.303 120.91 129.195 120.91C128.087 120.91 127.189 121.808 127.189 122.916C127.189 124.024 128.087 124.922 129.195 124.922Z"
          fill={color}
        />
        <path
          d="M20.0376 42.7049C21.1455 42.7049 22.0437 41.8068 22.0437 40.6988C22.0437 39.5909 21.1455 38.6927 20.0376 38.6927C18.9296 38.6927 18.0315 39.5909 18.0315 40.6988C18.0315 41.8068 18.9296 42.7049 20.0376 42.7049Z"
          fill={color}
        />
        <path
          d="M20.0377 42.7054C21.1456 42.7054 22.0438 41.8073 22.0438 40.6993C22.0438 39.5914 21.1456 38.6932 20.0377 38.6932C18.9298 38.6932 18.0316 39.5914 18.0316 40.6993C18.0316 41.8073 18.9298 42.7054 20.0377 42.7054Z"
          fill="black"
          fillOpacity="0.3"
        />
        <path
          d="M34.5037 64.7068C36.6965 64.7068 38.474 62.9292 38.474 60.7365C38.474 58.5438 36.6965 56.7662 34.5037 56.7662C32.311 56.7662 30.5334 58.5438 30.5334 60.7365C30.5334 62.9292 32.311 64.7068 34.5037 64.7068Z"
          fill="white"
        />
        <path
          d="M105.997 35.067L113.584 34.2431C114.3 34.164 114.905 34.7737 114.822 35.4905L113.928 43.3194C113.867 43.8407 113.453 44.255 112.932 44.3108L105.345 45.1347C104.628 45.2138 104.023 44.604 104.107 43.8872L105.001 36.0584C105.061 35.5371 105.475 35.1228 105.997 35.067Z"
          fill="white"
        />
        <path
          d="M85.3494 37.3104L92.9362 36.4865C93.653 36.4074 94.2581 37.0172 94.1743 37.7339L93.2807 45.5628C93.2202 46.0841 92.8059 46.4984 92.2846 46.5542L84.6978 47.3781C83.981 47.4572 83.3759 46.8474 83.4597 46.1307L84.3533 38.3018C84.4139 37.7805 84.8281 37.3662 85.3494 37.3104Z"
          fill="white"
        />
        <path
          d="M65.5074 39.4608L73.0942 38.6369C73.811 38.5578 74.4161 39.1675 74.3323 39.8843L73.4386 47.7132C73.3781 48.2345 72.9639 48.6487 72.4426 48.7046L64.8557 49.5285C64.1389 49.6076 63.5339 48.9978 63.6176 48.281L64.5113 40.4522C64.5718 39.9309 64.9861 39.5166 65.5074 39.4608Z"
          fill="white"
        />
        <path
          d="M45.1393 41.6717L52.7261 40.8479C53.4429 40.7687 54.048 41.3785 53.9642 42.0953L53.0706 49.9241C53.0101 50.4454 52.5958 50.8597 52.0745 50.9155L44.4877 51.7394C43.7709 51.8185 43.1658 51.2088 43.2496 50.492L44.1433 42.6631C44.2038 42.1418 44.618 41.7276 45.1393 41.6717Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_1522_113">
          <rect width="156" height="154.05" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

function DarkBackgroundOnDemandSVG({ color }: SVGInterface): JSX.Element {
  return (
    <svg width="156" height="155" viewBox="0 0 156 155" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1522_112)">
        <path
          opacity="0.1"
          d="M78.0001 0.00461314C63.4455 0.148902 51.772 1.27529 34.0477 12.8184C22.8117 20.1353 15.1225 32.1951 9.42075 44.3293C-8.93657 83.3945 3.55609 114.203 13.0373 126.23C16.9936 131.247 24.5991 137.294 30.1565 140.901C63.1941 162.33 99.5504 151.299 102.32 150.545C109.865 148.483 148.385 136.409 155.348 94.1185C155.93 90.595 156.312 87.0576 155.632 83.5528C154.273 76.5571 151.42 69.8592 147.315 64.0318C145.099 60.8854 142.516 57.9717 140.771 54.546C138.42 49.9334 137.736 44.6877 136.381 39.6888C129.265 13.3956 112.481 -0.339819 78.0001 0.00461314Z"
          fill="white"
        />
        <path
          d="M124.014 56.9104C123.991 56.4496 123.595 56.0959 123.135 56.1192L43.0633 60.4525C42.9888 59.0748 42.6072 57.7762 41.9695 56.6405L123.167 47.8295C123.474 47.7969 123.698 47.5223 123.661 47.2151L121.92 31.1757C121.724 29.3791 120.114 28.0852 118.317 28.2806L34.2617 37.3988C32.465 37.5943 31.1711 39.2047 31.3666 41.0014L32.5861 52.2606C28.4994 53.0379 25.4042 56.6218 25.4042 60.9366C25.4042 65.5585 28.9556 69.3472 33.4797 69.7382L35.8256 113.099C35.914 114.729 37.3057 115.981 38.9394 115.892L123.986 111.294C125.615 111.205 126.867 109.813 126.779 108.18L124.005 56.9104H124.014Z"
          fill={color}
        />
        <path
          d="M124.014 56.9108C123.991 56.45 123.595 56.0963 123.135 56.1195L43.0634 60.4529C42.989 59.0751 42.6073 57.7765 41.9696 56.6408L123.167 47.8299C123.474 47.7973 123.698 47.5227 123.661 47.2155L121.92 31.1761C121.724 29.3795 120.114 28.0855 118.317 28.281L34.2618 37.3992C32.4652 37.5946 31.1712 39.2051 31.3667 41.0017L32.5862 52.261C28.4995 53.0383 25.4043 56.6222 25.4043 60.9369C25.4043 65.5588 28.9557 69.3476 33.4798 69.7386L35.8257 113.1C35.9141 114.729 37.3058 115.981 38.9396 115.893L123.986 111.294C125.616 111.205 126.868 109.814 126.779 108.18L124.005 56.9108H124.014Z"
          fill="white"
          fillOpacity="0.8"
        />
        <path
          d="M93.6112 81.8027L75.5052 72.6147C74.2624 71.9863 72.8056 72.9358 72.8801 74.3229L73.9785 94.5932C74.053 95.9849 75.6076 96.7715 76.7712 96.0082L93.7787 84.9212C94.947 84.1625 94.8493 82.4217 93.6112 81.7933V81.8027Z"
          fill={color}
        />
        <path
          d="M138.634 115.636C140.937 115.636 142.804 113.769 142.804 111.466C142.804 109.163 140.937 107.295 138.634 107.295C136.331 107.295 134.464 109.163 134.464 111.466C134.464 113.769 136.331 115.636 138.634 115.636Z"
          fill={color}
        />
        <path
          d="M138.634 115.636C140.937 115.636 142.804 113.769 142.804 111.466C142.804 109.162 140.937 107.295 138.634 107.295C136.331 107.295 134.464 109.162 134.464 111.466C134.464 113.769 136.331 115.636 138.634 115.636Z"
          fill="white"
          fillOpacity="0.8"
        />
        <path
          d="M15.6019 50.464C17.2265 50.464 18.5436 49.1469 18.5436 47.5223C18.5436 45.8977 17.2265 44.5807 15.6019 44.5807C13.9773 44.5807 12.6603 45.8977 12.6603 47.5223C12.6603 49.1469 13.9773 50.464 15.6019 50.464Z"
          fill={color}
        />
        <path
          d="M129.195 124.922C130.303 124.922 131.201 124.024 131.201 122.916C131.201 121.808 130.303 120.91 129.195 120.91C128.087 120.91 127.189 121.808 127.189 122.916C127.189 124.024 128.087 124.922 129.195 124.922Z"
          fill={color}
        />
        <path
          d="M20.0376 42.7049C21.1455 42.7049 22.0437 41.8068 22.0437 40.6988C22.0437 39.5909 21.1455 38.6927 20.0376 38.6927C18.9296 38.6927 18.0315 39.5909 18.0315 40.6988C18.0315 41.8068 18.9296 42.7049 20.0376 42.7049Z"
          fill={color}
        />
        <path
          d="M20.0377 42.7054C21.1456 42.7054 22.0438 41.8073 22.0438 40.6993C22.0438 39.5914 21.1456 38.6932 20.0377 38.6932C18.9298 38.6932 18.0316 39.5914 18.0316 40.6993C18.0316 41.8073 18.9298 42.7054 20.0377 42.7054Z"
          fill="white"
          fillOpacity="0.6"
        />
        <path
          d="M34.5037 64.7068C36.6965 64.7068 38.474 62.9292 38.474 60.7365C38.474 58.5438 36.6965 56.7662 34.5037 56.7662C32.311 56.7662 30.5334 58.5438 30.5334 60.7365C30.5334 62.9292 32.311 64.7068 34.5037 64.7068Z"
          fill={color}
        />
        <path
          d="M105.997 35.067L113.584 34.2431C114.3 34.164 114.905 34.7737 114.822 35.4905L113.928 43.3194C113.867 43.8407 113.453 44.255 112.932 44.3108L105.345 45.1347C104.628 45.2138 104.023 44.604 104.107 43.8872L105.001 36.0584C105.061 35.5371 105.475 35.1228 105.997 35.067Z"
          fill={color}
        />
        <path
          d="M85.3494 37.3104L92.9362 36.4865C93.653 36.4074 94.2581 37.0172 94.1743 37.7339L93.2807 45.5628C93.2202 46.0841 92.8059 46.4984 92.2846 46.5542L84.6978 47.3781C83.981 47.4572 83.3759 46.8474 83.4597 46.1307L84.3533 38.3018C84.4139 37.7805 84.8281 37.3662 85.3494 37.3104Z"
          fill={color}
        />
        <path
          d="M65.5074 39.4608L73.0942 38.6369C73.811 38.5578 74.4161 39.1675 74.3323 39.8843L73.4386 47.7132C73.3781 48.2345 72.9639 48.6487 72.4426 48.7046L64.8557 49.5285C64.1389 49.6076 63.5339 48.9978 63.6176 48.281L64.5113 40.4522C64.5718 39.9309 64.9861 39.5166 65.5074 39.4608Z"
          fill={color}
        />
        <path
          d="M45.1393 41.6717L52.7261 40.8479C53.4429 40.7687 54.048 41.3785 53.9642 42.0953L53.0706 49.9241C53.0101 50.4454 52.5958 50.8597 52.0745 50.9155L44.4877 51.7394C43.7709 51.8185 43.1658 51.2088 43.2496 50.492L44.1433 42.6631C44.2038 42.1418 44.618 41.7276 45.1393 41.6717Z"
          fill={color}
        />
        <path
          d="M93.6112 81.8027L75.5052 72.6147C74.2624 71.9863 72.8056 72.9358 72.8801 74.3229L73.9785 94.5932C74.053 95.9849 75.6076 96.7715 76.7712 96.0082L93.7787 84.9212C94.947 84.1625 94.8493 82.4217 93.6112 81.7933V81.8027Z"
          fill="white"
          fillOpacity="0.1"
        />
        <path
          d="M34.5039 64.7068C36.6966 64.7068 38.4741 62.9292 38.4741 60.7365C38.4741 58.5438 36.6966 56.7662 34.5039 56.7662C32.3111 56.7662 30.5336 58.5438 30.5336 60.7365C30.5336 62.9292 32.3111 64.7068 34.5039 64.7068Z"
          fill="white"
          fillOpacity="0.1"
        />
        <path
          d="M105.997 35.067L113.584 34.2431C114.3 34.164 114.905 34.7737 114.822 35.4905L113.928 43.3194C113.867 43.8407 113.453 44.255 112.932 44.3108L105.345 45.1347C104.628 45.2138 104.023 44.604 104.107 43.8872L105.001 36.0584C105.061 35.5371 105.475 35.1228 105.997 35.067Z"
          fill="white"
          fillOpacity="0.1"
        />
        <path
          d="M85.3494 37.3104L92.9362 36.4865C93.653 36.4074 94.2581 37.0172 94.1743 37.7339L93.2807 45.5628C93.2202 46.0841 92.8059 46.4984 92.2846 46.5542L84.6978 47.3781C83.981 47.4572 83.3759 46.8474 83.4597 46.1307L84.3533 38.3018C84.4139 37.7805 84.8281 37.3662 85.3494 37.3104Z"
          fill="white"
          fillOpacity="0.1"
        />
        <path
          d="M65.5074 39.4608L73.0942 38.6369C73.811 38.5578 74.4161 39.1675 74.3323 39.8843L73.4386 47.7132C73.3781 48.2345 72.9639 48.6487 72.4426 48.7046L64.8557 49.5285C64.1389 49.6076 63.5339 48.9978 63.6176 48.281L64.5113 40.4522C64.5718 39.9309 64.9861 39.5166 65.5074 39.4608Z"
          fill="white"
          fillOpacity="0.1"
        />
        <path
          d="M45.1393 41.6717L52.7261 40.8479C53.4429 40.7687 54.048 41.3785 53.9642 42.0953L53.0706 49.9241C53.0101 50.4454 52.5958 50.8597 52.0745 50.9155L44.4877 51.7394C43.7709 51.8185 43.1658 51.2088 43.2496 50.492L44.1433 42.6631C44.2038 42.1418 44.618 41.7276 45.1393 41.6717Z"
          fill="white"
          fillOpacity="0.1"
        />
        <path
          d="M15.6018 50.4641C17.2264 50.4641 18.5434 49.1471 18.5434 47.5224C18.5434 45.8978 17.2264 44.5808 15.6018 44.5808C13.9772 44.5808 12.6602 45.8978 12.6602 47.5224C12.6602 49.1471 13.9772 50.4641 15.6018 50.4641Z"
          fill="white"
          fillOpacity="0.8"
        />
        <path
          d="M129.195 124.922C130.303 124.922 131.201 124.024 131.201 122.916C131.201 121.808 130.303 120.91 129.195 120.91C128.087 120.91 127.189 121.808 127.189 122.916C127.189 124.024 128.087 124.922 129.195 124.922Z"
          fill="white"
          fillOpacity="0.6"
        />
      </g>
      <defs>
        <clipPath id="clip0_1522_112">
          <rect width="156" height="154.05" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default function OnDemandSVG({ testID }: OnDemandSVGProps): JSX.Element {
  const { color, isLight } = useIllustrationColor();
  return (
    <svg
      width="156"
      height="156"
      viewBox="0 0 156 156"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...injectTestId(testID)}
    >
      {isLight ? <LightBackgroundOnDemandSVG color={color} /> : <DarkBackgroundOnDemandSVG color={color} />}
    </svg>
  );
}
